<template>
  <div class="kongzhi">
    <!-- 预约时间段控制 -->
    <div class="top">
      <p class="top-title">预约时间段控制</p>
      <div class="data">
        <div class="p-right">
          <!--默认 -->
          <div class="data-cont" v-show="dataLIst.length == 0">
            <TimePicker
              v-model="item.data"
              class="data-pick"
              format="HH:mm"
              confirm
              type="timerange"
              placement="bottom-start"
              placeholder="选择时间"
              @on-ok="getDataone()"
            ></TimePicker>
            <i-Switch
              size="large"
              class="switch-item"
              v-model="item.bl"
              @on-change="getDataone"
            >
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </i-Switch>
            <div style="display:inline-block;margin-left:30px;">
              限制人数数量：<Input
                @on-blur="getDataone"
                v-model="item.peopleNum"
                type="number"
                placeholder="请输入限制数量"
                style="width: 120px"
              ></Input>
            </div>
            <Icon class="i-icon i-icons" type="ios-remove-circle-outline" />
            <Icon
              @click="addData()"
              class="i-icon"
              type="ios-add-circle-outline"
            />
          </div>
          <!-- 有数据 -->
          <div
            v-show="dataLIst.length > 0"
            class="data-cont"
            v-for="(item, index) in dataLIst"
            :key="index"
          >
            <TimePicker
              v-model="item.data"
              class="data-pick"
              format="HH:mm"
              confirm
              type="timerange"
              placement="bottom-start"
              placeholder="选择时间"
              @on-ok="getData(index)"
            ></TimePicker>
            <i-Switch
              size="large"
              class="switch-item"
              v-model="item.bl"
              @on-change="getData(index)"
            >
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </i-Switch>
            <div style="display:inline-block;margin-left:30px;">
              限制人数数量：<Input
                v-model="item.peopleNum"
                type="number"
                @on-blur="getData(index)"
                placeholder="请输入限制数量"
                style="width: 120px"
              ></Input>
            </div>
            <Icon
              v-show="index !== 0"
              @click="reduceData(item, index)"
              class="i-icon"
              type="ios-remove-circle-outline"
            />
            <Icon
              v-show="index == 0"
              class="i-icon i-icons"
              type="ios-remove-circle-outline"
            />
            <Icon
              @click="addData(item, index)"
              class="i-icon"
              type="ios-add-circle-outline"
            />
          </div>
        </div>

        <div class="p-bottom" style="clear:both;height:20px;">\</div>
      </div>
    </div>
    <div class="top">
      <p class="top-title">特殊项目流量控制</p>
      <div class="data">
        <div class="p-right">
          <!-- 默认 -->
          <div class="data-cont" v-show="xiudataLIst.length == 0">
            <Select
              v-model="teitem.classifyId"
              style="width:180px;vertical-align: middle;"
              placeholder="请选择分类名称"
              @on-change="changeTimeSelect"
            >
              <Option
                v-for="(item, index) in cityList"
                :value="item.classifyId + ''"
                :key="item.classifyName"
                >{{ item.classifyName }}</Option
              >
            </Select>
            <Select
              v-model="teitem.timeId"
              style="width:180px;vertical-align: middle;"
              placeholder="请选择限制时段"
              @on-change="changeTimeSelect"
            >
              <Option
                v-show="item.startTime"
                v-for="(item, index) in dataLIst"
                :value="item.id + ''"
                :key="index"
                >{{ item.startTime + "-" + item.endTime }}</Option
              >
            </Select>
            <div style="display:inline-block;margin-left:30px;">
              限制人数数量：<Input
                v-model="teitem.peopleNum"
                type="number"
                placeholder="请输入限制数量"
                style="width: 120px"
                @on-blur="changeTimeSelects"
              ></Input>
            </div>
            <Icon class="i-icon i-icons" type="ios-remove-circle-outline" />
            <Icon
              @click="addxiuxiData()"
              class="i-icon"
              type="ios-add-circle-outline"
            />
          </div>
          <!-- y有数据 -->
          <div
            class="data-cont"
            v-show="xiudataLIst.length > 0"
            v-for="(item, index) in xiudataLIst"
            :key="index"
          >
            <Select
              v-model="item.classifyId"
              style="width:180px;vertical-align: middle;"
              placeholder="请选择分类名称"
              @on-change="changeSelect(index)"
            >
              <Option
                v-for="(item, index1) in cityList"
                :value="item.classifyId + ''"
                :key="item.classifyName"
                >{{ item.classifyName }}</Option
              >
            </Select>
            <Select
              v-model="item.timeId"
              style="width:180px;vertical-align: middle;"
              placeholder="请选择限制时段"
              @on-change="changeSelectTime(index)"
            >
              <Option
                v-show="item.startTime"
                v-for="(item, index2) in dataLIst"
                :value="item.id + ''"
                :key="index2"
                >{{ item.startTime + "-" + item.endTime }}</Option
              >
            </Select>
            <div style="display:inline-block;margin-left:30px;">
              限制人数数量：<Input
                v-model="item.peopleNum"
                type="number"
                placeholder="请输入限制数量"
                style="width: 120px"
                @on-blur="changeSelectNum(index)"
              ></Input>
            </div>
            <Icon
              v-show="index !== 0"
              @click="reducexiuxiData(item, index)"
              class="i-icon"
              type="ios-remove-circle-outline"
            />
            <Icon
              v-show="index == 0"
              class="i-icon i-icons"
              type="ios-remove-circle-outline"
            />
            <Icon
              @click="addxiuxiData(item, index)"
              class="i-icon"
              type="ios-add-circle-outline"
            />
          </div>
        </div>
        <div class="p-bottom" style="clear:both;height:20px;"></div>
      </div>
    </div>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        selectBookingTime,
        addOrUpdateBookingTime,
        deleteBookingTime,
        selectBookingTimeFeeItem,
        selectClassifyAll,
        addOrUpdateBookingTimeFeeItem,
        deleteBookingTimeFeeItem
    } from "../servers/api";
    export default {
        name: "shijian",
        data() {
            return {
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                cityList: [{
                    value: "Sydney",
                    label: "Sydney"
                }, {
                    value: "Ottawa",
                    label: "Ottawa"
                }, {
                    value: "Paris",
                    label: "Paris"
                }, {
                    value: "Canberra",
                    label: "Canberra"
                }],
                fruit: [],
                item: {
                    data: [],
                    peopleNum: "",
                    bl: false
                },
                teitem: {
                    classifyId: "",
                    timeId: "",
                    peopleNum: ""
                },
                dataLIst: [
                    // {
                    //   id: 1,
                    //   data: [],
                    //   peopleNum: '',
                    //   bl: true
                    // }
                ],
                xiudataLIst: [
                    // {
                    //   id: 1,
                    //   data: [],
                    //   num: '',
                    //   jia: ''
                    // }
                ]
            };
        },
        methods: {
            changeSelect(index) {
                //特殊流量控制 有数据时带有id修改
                this.addOrUpdateBookingTimeFeeItem(this.xiudataLIst[index]);
            },
            changeSelectNum(index) {
                //特殊流量控制人员输入框离焦事件
                if (
                    this.xiudataLIst[index].timeId == "" ||
                    !this.xiudataLIst[index].timeId
                ) {
                    this.xiudataLIst[index].peopleNum = "";
                    return;
                }
                if (
                    parseInt(this.xiudataLIst[index].peopleNum) >
                    parseInt(this.xiudataLIst[index].maxNum)
                ) {
                    this.xiudataLIst[index].peopleNum = this.xiudataLIst[index].maxNum;
                    this.addOrUpdateBookingTimeFeeItem(this.xiudataLIst[index]);
                } else {
                    this.addOrUpdateBookingTimeFeeItem(this.xiudataLIst[index]);
                }
            },
            changeSelectTime(index) {
                //特殊控制 选择时间 设置最多限制人数  timeId
                for (let i = 0; i < this.dataLIst.length; i++) {
                    if (this.dataLIst[i].id == this.xiudataLIst[index].timeId) {
                        this.xiudataLIst[index].maxNum = this.dataLIst[i].peopleNum;
                    }
                }
                if (this.xiudataLIst[index].peopleNum > this.xiudataLIst[index].maxNum) {
                    this.xiudataLIst[index].peopleNum = this.xiudataLIst[index].maxNum;
                }
                this.addOrUpdateBookingTimeFeeItem(this.xiudataLIst[index]);
            },
            changeTimeSelects(e) {
                //特殊流量默认的进行添加
                if (this.teitem.timeId == "") {
                    this.teitem.peopleNum = "";
                    return;
                }
                this.addOrUpdateBookingTimeFeeItem(this.teitem);
            },
            changeTimeSelect() {
                this.addOrUpdateBookingTimeFeeItem(this.teitem);
            },
            addOrUpdateBookingTimeFeeItem(item) {
                //增加或者修改特殊流量控制接口
                this.isiconfontshow = true;
                addOrUpdateBookingTimeFeeItem(item).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.selectBookingTimeFeeItem();
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            selectClassifyAll() {
                //查询fenlei列表
                selectClassifyAll({}).then(res => {
                    if (res.data.code == 1) {
                        this.cityList = res.data.data || [];
                    }
                });
            },
            selectBookingTimeFeeItem() {
                //查询特殊时间段控制
                selectBookingTimeFeeItem({}).then(res => {
                    this.isiconfontshow = true;
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        let list = res.data.data || [];
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].classifyId) {
                                list[i].classifyId = list[i].classifyId + "";
                            }
                            if (list[i].timeId) {
                                list[i].timeId = list[i].timeId + "";
                                for (let k = 0; k < this.dataLIst.length; k++) {
                                    if (this.dataLIst[k].id == parseInt(list[i].timeId)) {
                                        list[i].maxNum = this.dataLIst[k].peopleNum;
                                    }
                                }
                            }
                        }
                        this.xiudataLIst = list;
                    } else {
                        this.isiconfontshow = false;
                    }
                });
            },
            getDataone() {
                //预约列表为空时默认展示的数据进行操作 - 时间段
                let status = 0;
                if (this.item.bl) {
                    status = 1;
                }
                this.addOrUpdateBookingTime({
                    peopleNum: this.item.peopleNum || "",
                    startTime: this.item.data[0],
                    endTime: this.item.data[1],
                    status: status
                });
            },
            getData(e) {
                //修改 带有id的
                let status = 0;
                if (this.dataLIst[e].bl) {
                    status = 1;
                }
                this.addOrUpdateBookingTime({
                    id: this.dataLIst[e].id,
                    startTime: this.dataLIst[e].data[0] || "",
                    endTime: this.dataLIst[e].data[1] || "",
                    status: status,
                    peopleNum: this.dataLIst[e].peopleNum || ""
                });
            },
            reduceData(item, index) {
                //删除预约时间段控制
                deleteBookingTime({
                    id: item.id
                }).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.selectBookingTime();
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            reducexiuxiData(item, index) {
                //删除
                this.isiconfontshow = true;
                deleteBookingTimeFeeItem({
                    id: item.id
                }).then(res => {
                    if (res.data.code == 1) {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.selectBookingTimeFeeItem();
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    }
                });
            },

            addxiuxiData(item, index) {
                //新增特殊流量控制
                this.addOrUpdateBookingTimeFeeItem({
                    peopleNum: "",
                    classifyId: "",
                    timeId: ""
                });
            },
            addOrUpdateBookingTime(item) {
                //修改和新增接口预约时间段控制
                this.isiconfontshow = true;
                addOrUpdateBookingTime(item).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.selectBookingTime();
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            selectBookingTime() {
                //查询时间段控制
                selectBookingTime({}).then(res => {
                    this.isiconfontshow = true;
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        let list = res.data.data || [];

                        for (let i = 0; i < list.length; i++) {
                            list[i].data = [list[i].startTime || "", list[i].endTime || ""];
                            if (list[i].status && list[i].status == 1) {
                                //开启
                                list[i].bl = true;
                            } else {
                                list[i].bl = false;
                            }
                        }
                        this.dataLIst = list;
                    } else {
                        this.isiconfontshow = false;
                    }
                });
            },
            addData(item, index) {
                //添加预约时间段控制
                this.addOrUpdateBookingTime({
                    peopleNum: "",
                    startTime: "",
                    endTime: "",
                    status: "0"
                });
            }
        },
        created() {
            this.selectBookingTime();
            this.selectClassifyAll();
            this.selectBookingTimeFeeItem();
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .ive-cont {
        padding-left: 50px;
    }
    
    .ivu-switch-checked /deep/ {
        background-color: #53cac3;
        border-color: #53cac3;
        vertical-align: middle;
        margin-left: 30px;
    }
    
    .switch-item /deep/ {
        vertical-align: middle;
        margin-left: 30px;
    }
    
    .ivumodal-p {
        margin-top: 15px;
        color: red;
    }
    
    .kongzhi {
        padding: 15px;
        padding-top: 0;
        font-size: 13px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .top {
            padding-left: 15px;
            padding-top: 15px;
            // padding-bottom: 15px;
            border-bottom: 1px dashed #53cac3;
            position: relative;
            .top-title {
                font-size: 16px;
            }
        }
        .tops {
            border: none;
        }
        .check-box {
            margin-left: 50px;
            margin-top: 15px;
            span {
                padding-left: 10px;
            }
        }
        .data {
            padding: 15px;
            padding-left: 30px;
            .secondp {
                padding-left: 27px;
                margin-top: 5px;
            }
            .span {
                margin-left: 200px;
                font-size: 30px;
                color: #53cac3;
            }
        }
        .data-pick {
            width: 274px;
        }
        .i-icon {
            font-size: 25px;
            font-weight: 700;
            line-height: 30px;
            vertical-align: middle;
            color: #53cac3;
            margin-left: 15px;
            cursor: pointer;
        }
        .i-icons {
            color: #fff;
        }
        .p-left {
            float: left;
            line-height: 60px;
        }
        .p-right {
            float: left;
        }
        .p-bottom {
            clear: both;
            padding-top: 15px;
        }
        .data-cont {
            margin-top: 15px;
        }
        .bottom-left {
            float: left;
            // padding-right: 250px;
            width: 670px;
        }
        .clear {
            clear: both;
        }
        .title-btn {
            position: absolute;
            left: 670px;
            bottom: 15px;
        }
        .check {
            padding-left: 40px;
            margin-top: 15px;
        }
    }
    
    .input-max {
        margin-top: 15px;
        .ivu-input-wrapper {
            margin-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/yuyue/shijian.vue